import { toEnDigit } from "./convertDigit";

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function onlyNumbers(string: any, { canStartWithZero = false } = {}): string {
  const initValue = toEnDigit(string);
  const value = String((canStartWithZero ? initValue : initValue.replace(/^0+/, "")) || 0);
  let strResult = "";
  if (/^\d+$/.test(value)) {
    strResult = value;
  } else {
    strResult = value.replace(/[^\d]/g, "");
  }
  return canStartWithZero ? strResult : strResult.replace(/^0+/, "");
}
